import { render, staticRenderFns } from "./_highlight.vue?vue&type=template&id=a5d4f9a8&lang=pug&"
import script from "./_highlight.vue?vue&type=script&lang=js&"
export * from "./_highlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports